import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Calendar, momentLocalizer } from "react-big-calendar";
import * as actions from 'store/actions';
import { connect } from 'react-redux';
import { cancelAppointment_, getAppointmentList, getAppointmentSlots, rescheduleAppointment_ } from 'store/services/appointmentService';
import moment from "moment/moment";
import momentTZ from "moment-timezone";

// icn
import { ReactComponent as OTick } from "Assets/Images/icn/OrangeTick.svg";
import { currentDayFromMonth_, utcTimestamp_, currentDayFromMonth, bookingdate, bookingdatetime, convertTimezone, isDateValid, getAppointmentDateTime, convertLocalDateToUTC, getMonthStartAndEndDates } from 'helpers/common'
import { CONFIRM_POPUP, SUCCESS_MESSAGE } from "common/constantMessage";
import { getPractitionerSettings } from "store/services/authService";
import { CALENDAR_ERROR } from "common/constants";
import { dashboard } from "store/services/appService";
import MyCalendar from "components/shared/MyCalendar";
import AppTooltip from "components/shared/CommonTooltip";
const AppointmentDetailsPopup = ({ dispatch, reschedulePop, setReschedulePop, setShowPopup, currentDetail, setCurrentDetail, accountList, setCurrentTypeData, currentTypeData, practSettingsList }) => {
  const [stepRes, setStepRes] = useState(1);
  const [timeZoneValue, setTimeZoneValue] = useState(moment.tz.guess())
  const localizer = momentLocalizer(moment);
  const [selectedDay_, setSelectedDay_] = useState(null);
  const [currentRescheduledSLot, setCurrentRescheduledSLot] = useState(null);

  const [availableTimes, setAvailableTimes] = useState(null);

  const [selectedDate, setSelectedDate] = useState(new Date()); // State to track the selected date
  const [stateSlotsVal, setStateSlotsVal] = useState([])
  const [finalResResponse, setFinalResResponse] = useState()
  const [showButton, setShowButton] = useState(false)

  const [blockDateSettings, setBlockDateSettings] = useState(null);

  const [isCancelling, setIsCancelling] = useState(false);
  const [calendarError, setCalendarError] = useState(null);

  const cancellationAllowed = useMemo(() => {

    const currentTime = moment();
    const apptStartTime = moment(currentDetail?.start_time);
    const allowedCancellation = practSettingsList?.scheduler_allow_cancellations;

    const diffInHours = Number(apptStartTime.diff(currentTime, "hours", true).toFixed(2));

    switch (allowedCancellation) {
      case "anytime":
        return true;

      case "24h_before":
        return diffInHours >= 24;

      case "48h_before":
        return diffInHours >= 48;

      case "no_cancellation":
        return false;

      default:
        return true;
    }

  }, [currentDetail, practSettingsList])

  const reschedulingAllowed = useMemo(() => {

    const currentTime = moment();
    const apptStartTime = moment(currentDetail?.start_time);
    const allowedRescheduling = practSettingsList?.scheduler_allow_rescheduling;

    const diffInHours = Number(apptStartTime.diff(currentTime, "hours", true).toFixed(2));

    switch (allowedRescheduling) {
      case "anytime":
        return true;

      case "24h_before":
        return diffInHours >= 24;

      case "48h_before":
        return diffInHours >= 48;

      case "no_rescheduling":
        return false;

      default:
        return true;
    }

  }, [currentDetail, practSettingsList])

  useEffect(() => {
    getPractSetttings();
  }, [])

  useEffect(() => {
    if (stepRes !== 3 || !currentTypeData) {
      return;
    }
    getPractitionerAvailability(currentTypeData, selectedDate);
  }, [stepRes, currentTypeData])

  const checkIfDateValid = (date) => {
    return isDateValid(date, practSettingsList);
  }

  const handleSelectEvent = event => {
    // Handle event selection if needed
    console.log('Event selected:', event);
  };

  const handleNavigate = (date) => {
    getPractitionerAvailability(currentTypeData, date);
    if (!checkIfDateValid(date)) {
      setCalendarError(CALENDAR_ERROR);
      return;
    }
    setSelectedDate(date);
    setCalendarError(null);
  };

  const handleSelectSlot = (slotInfo) => {
    const newSelectedDate = moment(slotInfo.start).toDate();
    if (!checkIfDateValid(newSelectedDate)) {
      setCalendarError(CALENDAR_ERROR);
      return;
    }
    setSelectedDate(newSelectedDate);
    setCalendarError(null);
  };

  useEffect(() => {
    if (!selectedDate || !availableTimes?.days?.length) {
      return;
    }
    const parsedDate = moment(selectedDate).format("YYYY-MM-DD");
    const findAvailability = availableTimes?.days.find(row => row.date === parsedDate);
    if (!findAvailability || !findAvailability?.available || !findAvailability?.spots?.length) {
      setStateSlotsVal([]);
      return;
    }
    setStateSlotsVal(findAvailability?.spots);
  }, [selectedDate, availableTimes])

  useEffect(() => {
    // setSelectedDate(currentDetail?.booking_date)
  }, [currentDetail])

  useEffect(() => {
    if (practSettingsList) {
      let calendarBlocks = practSettingsList["scheduler_blocked_dates"];
      if (!calendarBlocks) {
        return;
      }

      calendarBlocks = JSON.parse(calendarBlocks);
      setBlockDateSettings(calendarBlocks);
    }
  }, [practSettingsList])

  const onClickAppointType = async (data, day) => {
    try {
      setCurrentTypeData(data);
      let finalObj = {
        appointmentTypeId: data?.id,
        values: {
          day: day,
          duration: parseInt(data?.duration),
          hours: data?.available_working_hours,
          booking_date: convertLocalDateToUTC(selectedDate, "YYYY-MM-DD"),
          client_appt_tz: timeZoneValue
        }
      }
      dispatch(actions.persist_store({ loader: true }));
      // setButtonDisable(true)
      let res = await dispatch(getAppointmentSlots(finalObj));
      dispatch(actions.persist_store({ loader: false }));
      setStateSlotsVal(res?.body?.slots)

    } catch (err) {
      console.log(err);
      // setButtonDisable(false)
      dispatch(actions.persist_store({ loader: false }));
    }
  };

  const getPractitionerAvailability = async (apptType, selectedDate) => {
    try {
      const range = getMonthStartAndEndDates(selectedDate);
      if (!range) {
        throw "Month range not valid";
      }

      let finalObj = {
        appointmentTypeId: apptType?.id,
        values: {
          start_date: range?.start,
          end_date: range?.end,
          client_appt_tz: timeZoneValue,
        }
      }
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(getAppointmentSlots(finalObj));
      dispatch(actions.persist_store({ loader: false }));
      setAvailableTimes(res?.body);
    } catch (err) {
      console.error("Error fetching availability", err);
      dispatch(actions.persist_store({ loader: false }));
    }
  }


  const eventStyleGetter = (event, start, end, isSelected) => {
    const style = {
      backgroundColor: event.color,
      borderRadius: "5px",
      opacity: 0.8,
      color: "white",
      border: "0px",
      display: "block",
      width: "100%",
    };
    return {
      style,
    };
  };
  const Trips = [
    {
      title: "Trip to Paris",
      start: new Date(2023, 6, 15), // July 15, 2023
      end: new Date(2023, 6, 20), // July 20, 2023
    },
    {
      title: "Beach Vacation",
      start: new Date(2023, 7, 5), // August 5, 2023
      end: new Date(2023, 7, 12), // August 12, 2023
    },
    // Add more trips as needed
  ];
  const handleReschedulePop = () => {
    setReschedulePop(false);
    setStepRes(1);
    setCurrentDetail(null);
    setCurrentTypeData(null);
  }

  const cancelAppointment = async () => {
    try {
      let data = {
        id: currentDetail.id,
      }

      await CONFIRM_POPUP("Are you sure you want to cancel this appointment?")
        .then(async (isConfirmed) => {
          if (isConfirmed) {
            setIsCancelling(true);
            dispatch(actions.persist_store({ loader: true }));
            let res = await cancelAppointment_(data);
            if (res.success === true) {
              SUCCESS_MESSAGE("Appointment cancelled");
              await dispatch(dashboard());
              cancelAppointmentPop_();
            }
            setIsCancelling(false);
            dispatch(actions.persist_store({ loader: false }));
          }
        }).catch(err => {
          setIsCancelling(false);
          dispatch(actions.persist_store({ loader: false }));
          throw err
        })

    } catch (err) {
      console.log("Error cancelling the appointment", err);
      dispatch(actions.persist_store({ loader: false }));
    }
  }

  const cancelAppointmentPop_ = () => {
    setReschedulePop(false);
    setStepRes(1);
  }
  const cancelRes_ = () => {
    setStepRes(1);
  }

  const slotselctForBooking = (slot) => {
    setCurrentRescheduledSLot(slot);
    setStepRes(2)
    setShowPopup(false)
    setReschedulePop(true)
  }

  const confirmResAppointment = async () => {
    try {
      let finalObj = {
        booking_date: moment().format("YYYY-MM-DD"),
        start_time: getAppointmentDateTime(currentRescheduledSLot.date, currentRescheduledSLot.start_time, timeZoneValue),
        end_time: getAppointmentDateTime(currentRescheduledSLot.date, currentRescheduledSLot.end_time, timeZoneValue, true, currentRescheduledSLot.start_time),
        appointment_timezone: timeZoneValue,
      }
      dispatch(actions.persist_store({ loader: true }));
      setShowButton(true)
      let res = await dispatch(rescheduleAppointment_(currentDetail?.id, finalObj));
      await dispatch(dashboard());
      dispatch(actions.persist_store({ loader: false }));
      setShowButton(false)
      setFinalResResponse(res?.body)
      setStepRes(4)
    } catch (err) {
      console.log(err);
      setShowButton(false)
      dispatch(actions.persist_store({ loader: false }));
    }
  }

  const getPractSetttings = async () => {
    try {
      await dispatch(getPractitionerSettings());
    } catch (err) {
      console.log("Error fetching pracitioner settings", err);
    }
  }

  const checkIfValidDay = (date) => {
    try {
      let isValid = checkIfDateValid(date);
      if (!isValid) {
        return {
          className: "blocked-day"
        }
      }

    } catch (err) {
      // console.log("Error validating date", err);
    }
  }

  return (
    <>
      {stepRes === 1 &&
        <Modal
          show={reschedulePop}
          onHide={handleReschedulePop}
          backdrop="static"
          keyboard={false}
          scrollable="true"
          centered
          className="reschedulePop FormPop"
        >
          <Modal.Header closeButton>
            <Modal.Title className="fw-sbold">Appointment Details</Modal.Title>
          </Modal.Header>
          <Modal.Body className="px-lg-4">
            <div className="commenContent commonCardBox px-lg-4 p-3 bg-white">
              <div className="top py-2 border-bottom bg-white ">
                <h2 className="m-0">
                  Your Appointment
                </h2>
                <p className="m-0 py-2">
                  Edit your previously booked appointment
                </p>
              </div>
              <div className="CardBody py-3">

                <div className="py-2">
                  <div
                    className="commonCardBox p-3"
                    style={{ background: "#f6f6f6" }}
                  >
                    <div className="top py-2">
                      <h4 className="m-0 fw-sbold">{currentDetail?.title}</h4>
                      <span className="text-muted m-0">
                        (duration : {currentDetail?.duration} minutes)
                      </span>
                    </div>

                    <div className="content">

                      <div className="py-2">
                        <h6 className="m-0">{moment(currentDetail?.start_time).format("hh:mm A")} to {moment(currentDetail?.end_time).format("hh:mm A")} on {currentDayFromMonth_(currentDetail?.start_time)}</h6>
                      </div>
                      {(currentTypeData?.location === 'in_person' && currentTypeData?.in_person_address) && (
                        <div className="py-2">
                          <p className="m-0"><strong>Appointment Location</strong></p>
                          <p className="m-0">{currentTypeData?.in_person_address}</p>
                        </div>
                      )}
                      {currentTypeData?.location_notes && (
                        <div className="py-2">
                          <p className="m-0">
                            <strong>
                              {currentTypeData?.location === 'by_phone'
                                ? 'By Phone' : currentTypeData?.location === 'in_person'
                                  ? 'In Person' : currentTypeData?.location === 'video_zoom'
                                    ? 'Video/Zoom' : ''
                              }{` `}
                              Instructions
                            </strong>
                          </p>
                          <p className="m-0">{currentTypeData?.location_notes}</p>
                        </div>
                      )}
                      {(currentTypeData?.location === "video_zoom" && currentTypeData?.video_url) && (
                        <p>
                          Video Link:{" "}
                          <a
                            href={currentTypeData?.video_url}
                            target="_blank"
                          >
                            {currentTypeData?.video_url}
                          </a>
                        </p>
                      )}
                      {currentTypeData?.additonal_notes && (
                        <div className="py-2">
                          <p className="m-0">
                            <strong>Additional Notes</strong>
                          </p>
                          <p className="m-0">{currentTypeData?.additonal_notes}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <h6 className="m-0 fw-sbold">Need to reschedule or cancel ?</h6>
                <div className="top py-2">
                  <div>
                    {reschedulingAllowed ? (
                      <Link onClick={() => setStepRes(3)}>
                        <span className="text m-0">
                          Reschedule Appointment
                        </span>
                      </Link>
                    ) : (
                      <p className="text-muted disabled m-0">
                        <span className="text m-0">
                          <AppTooltip
                            text={
                              practSettingsList?.scheduler_allow_rescheduling === "24h_before"
                                ? "You can reschedule an appointment up to 24 hours before its start time."
                                : practSettingsList?.scheduler_allow_rescheduling === "48h_before"
                                  ? "You can reschedule an appointment up to 48 hours before its start time."
                                  : practSettingsList?.scheduler_allow_rescheduling === "no_rescheduling"
                                    ? "You can not reschedule this appointment."
                                    : ""
                            }
                          >
                            <span>Reschedule Appointment <i className="fa fa-info-circle"></i></span>
                          </AppTooltip>
                        </span>
                      </p>
                    )}
                  </div>
                  <div>
                    {cancellationAllowed ? (
                      <Link onClick={() => cancelAppointment()}>
                        <span className="text m-0">
                          {isCancelling ? "Please wait..." : "Cancel Appointment"}
                        </span>
                      </Link>
                    ) : (
                      <p className="text-muted disabled m-0">
                        <span className="text m-0">
                          <AppTooltip
                            text={
                              practSettingsList?.scheduler_allow_cancellations === "24h_before"
                                ? "You can cancel an appointment up to 24 hours before its start time."
                                : practSettingsList?.scheduler_allow_cancellations === "48h_before"
                                  ? "You can cancel an appointment up to 48 hours before its start time."
                                  : practSettingsList?.scheduler_allow_cancellations === "no_cancellation"
                                    ? "You can not cancel this appointment."
                                    : ""
                            }
                          >
                            <span>Cancel Appointment <i className="fa fa-info-circle"></i></span>
                          </AppTooltip>
                        </span>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="FormbtnWrpper">
            <Button
              onClick={handleReschedulePop}
              className="d-flex align-items-center justify-content-center commonBtn"
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      }
      {stepRes === 2 &&
        <Modal
          show={reschedulePop}
          onHide={handleReschedulePop}
          backdrop="static"
          keyboard={false}
          scrollable="true"
          centered
          className="reschedulePop FormPop"
        >
          <Modal.Header closeButton>
            <Modal.Title className="fw-sbold">Reschedule your Appointment</Modal.Title>
          </Modal.Header>
          <Modal.Body className="px-lg-4">
            <div className="commenContent commonCardBox px-lg-4 p-3 bg-white">
              <div className="top py-2 border-bottom bg-white ">
                <h3 className="m-0">
                  Confirm reschedule appointment.
                </h3>
                <p className="m-0 py-2">
                  <Link onClick={() => cancelRes_()}>Cancel Rescheduling</Link>
                </p>
              </div>
              <div className="CardBody py-3">
                <div className="py-2">
                  <div
                    className="commonCardBox p-3"
                    style={{ background: "#f6f6f6" }}
                  >
                    <div className="top py-2">
                      <h4 className="m-0 fw-sbold">{currentDetail?.title}</h4>
                      <span className="text-muted m-0">
                        (duration : {currentDetail?.duration} minutes)
                      </span>
                    </div>
                    <div className="py-2">
                      <h6 className="m-0">{(currentRescheduledSLot?.start_time)} to {(currentRescheduledSLot?.end_time)} on {currentDayFromMonth_(currentRescheduledSLot?.date, timeZoneValue)}</h6>
                    </div>
                    <br />
                    <h6 className="m-0 fw-sbold">What's Changing:</h6>
                    <div className="top py-2">
                      <span className="text m-0">
                        <Link to="#">Old Appointment</Link>: {moment(currentDetail?.start_time).format("hh:mm A")} to {moment(currentDetail?.end_time).format("hh:mm A")} on {currentDayFromMonth_(currentDetail?.start_time)}
                      </span><br />
                      <span className="text m-0">
                        <Link to="#">New Appointment</Link>: {(currentRescheduledSLot?.start_time)} to {(currentRescheduledSLot?.end_time)} on {currentDayFromMonth_(currentRescheduledSLot?.date)}
                      </span>
                      <br />
                    </div>
                    <br />
                    <span className="text-muted m-0">
                      Please confirm that the updated data and time is correct. Once you click'Confirm Rescheduled Appointment' your old appointment will be canceled and rescheduled to the updated date and time above.
                    </span>
                  </div>
                </div>
                <div className="d-flex gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center btnSm btn-danger"
                    onClick={() => cancelAppointmentPop_()}
                  >
                    Cancel Rescheduling
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn btnSm"
                    onClick={() => confirmResAppointment()}
                    disabled={showButton ? true : false}
                  >
                    {showButton ? 'Wait...' : 'Confirm Rescheduled Appointment'}
                  </Button>
                </div>

              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="FormbtnWrpper">
            <Button
              onClick={handleReschedulePop}
              className="d-flex align-items-center justify-content-center commonBtn"
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      }
      {stepRes === 3 &&
        <Modal
          show={reschedulePop}
          onHide={handleReschedulePop}
          backdrop="static"
          keyboard={false}
          scrollable="true"
          centered
          className="reschedulePop FormPop"
        >
          <Modal.Header closeButton>
            <Modal.Title className="fw-sbold"> Reschedule your Appointment</Modal.Title>
          </Modal.Header>
          <Modal.Body className="px-lg-4">
            <div className="commenContent commonCardBox px-lg-4 p-3 bg-white">
              <div className="top py-2 border-bottom bg-white ">

                <p className="m-0">
                  Select a highlighted date in the calendar to view
                  available times below.
                </p>
                <p className="m-0">
                  All dates/times are in <b> {timeZoneValue}</b>{" "}
                  time zone.
                </p>
                <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center py-2 gap-10">
                  <li className="">
                    <Button
                      onClick={() => cancelAppointmentPop_()}
                      className="themeLink fw-sbold border-0 p-0"
                      variant="transparent"
                    >
                      Cancel Rescheduling
                    </Button>
                  </li>
                </ul>
              </div>
              <div className="py-2">
                <h6 className="m-0">{currentDetail?.title}</h6>
              </div>
              <div className="py-2">
                <h6 className="m-0">Duration : {currentDetail?.duration} minutes</h6>
              </div>
              {currentDetail?.is_paid_appointment === 'yes' &&
                <div className="py-2">
                  <h6 className="m-0">Price : {currentDetail?.currency_sign}{currentDetail?.price}</h6>
                </div>
              }
              <div className="CardBody py-3">
                <Row>
                  <Col lg="12" className="my-2">
                    <MyCalendar
                      localizer={localizer}
                      events={Trips}
                      eventPropGetter={eventStyleGetter}
                      startAccessor="start"
                      endAccessor="end"
                      onSelectEvent={handleSelectEvent}
                      // defaultDate={selectedDate}
                      views={['month']}
                      onNavigate={handleNavigate}
                      style={{ height: 500 }}
                      selectable
                      selected={selectedDate}
                      onSelectSlot={handleSelectSlot}
                      dayPropGetter={checkIfValidDay}
                      longPressThreshold={1}
                    />
                    {calendarError &&
                      <p className="invalid-feedback d-block">{calendarError}</p>
                    }
                  </Col>
                  {selectedDate && (
                    <Col lg="12" className="my-2">
                      <div className="commonContent">
                        <h4 className="m-0 py-2">
                          Open Times on {currentDayFromMonth_(selectedDate)}
                        </h4>
                        {timeZoneValue && (
                          <p>
                            All dates/times are in <strong>{timeZoneValue}</strong> time zone.
                          </p>
                        )}
                        <ul className="list-unstyled ps-0 mb-0 py-2">
                          {stateSlotsVal.length > 0 ? (
                            <>
                              {stateSlotsVal.map((slot, i) => {
                                return (
                                  <li className="py-1" key={i}>
                                    <div
                                      className="commonCardBox p-2 d-flex align-items-center justify-content-between gap-10 flex-wrap"
                                      style={{ background: "#f6f6f6" }}
                                    >
                                      <h6 className="m-0 py-2">
                                        {slot.start_time} to {slot.end_time} on {currentDayFromMonth(slot.date)}
                                      </h6>
                                      <Button
                                        onClick={() => slotselctForBooking(slot)}
                                        className="d-flex align-items-center justify-content-center commonBtn btnSm px-4"
                                        disabled={slot?.is_booked}
                                      >
                                        Select
                                      </Button>
                                    </div>
                                  </li>
                                )
                              })}
                            </>
                          ) : (
                            <p className="m-0">No slots found, please choose another date/time.</p>
                          )}
                        </ul>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      }
      {stepRes === 4 &&
        <Modal
          show={reschedulePop}
          onHide={handleReschedulePop}
          backdrop="static"
          keyboard={false}
          scrollable="true"
          centered
          className="reschedulePop FormPop"
        >
          <Modal.Header closeButton>
            <Modal.Title className="fw-sbold">Your Appointment</Modal.Title>
          </Modal.Header>
          <Modal.Body className="px-lg-4">
            <div className="commenContent commonCardBox px-lg-4 p-3 bg-white">
              <div className="top py-2 border-bottom bg-white ">
                <h3 className="m-0">
                  Appointment Rescheduled!
                </h3>
              </div>
              <div className="CardBody py-3">
                <div className="py-2">
                  <span className="text-muted m-0">
                    Your appointment has been rescheduled. We have also sent you an email confirmations as well.
                  </span>
                  <div
                    className="commonCardBox p-3"
                    style={{ background: "#f6f6f6" }}
                  >
                    <div className="top py-2">
                      <h4 className="m-0 fw-sbold">{finalResResponse?.title}</h4>
                      <span className="text-muted m-0">
                        (duration : {finalResResponse?.duration} minutes)
                      </span>
                    </div>
                    <div className="py-2">
                      <h6 className="m-0">{currentRescheduledSLot?.start_time} to {currentRescheduledSLot?.end_time} on {currentDayFromMonth_(currentRescheduledSLot?.date)}</h6>
                    </div>
                    <br />
                    <span className="text-success m-0">
                      {finalResResponse && `Everything is complete. Your confirmation code is ${finalResResponse?.uuid}. `}<br />
                      Please click the 'Close' button to close this window.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="FormbtnWrpper">
            <Button
              onClick={handleReschedulePop}
              className="d-flex align-items-center justify-content-center commonBtn"
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      }
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    accountList: state?.AccountSetting?.accountSettingList,
    practSettingsList: state.Auth.practitionerSettings,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(AppointmentDetailsPopup);
